import { IInputSelectOptions } from '@shared/components/v1/input/input-select-autocomplete/input-select-autocomplete.interface';
import { IGenericCheckbox } from '@shared/interface/generic';

export class IChips {
  id: string;
  name: string;
  selected?: boolean;
  disabled?: boolean;
}

export interface IChipsConfig {
  disabled?: boolean;
  labelTextStyle?: 'capitalize' | 'uppercase';
  showLimit?: boolean;
  limit?: number;
  clickToSelect?: boolean;
}

export class ISelectOptionsToChips extends IChips {
  setChips(_selector: IInputSelectOptions) {
    const { value, label } = _selector;
    this.id = value;
    this.name = label;
    this.selected = true;
  }
}

export interface IChipsWithArea extends IChips, IGenericCheckbox {
  area?: string;
  sub_area?: string;
}

// Passthrough tipe item sumber asli (mis. IRetailer) yang ditempelin konsumen ke tiap chip —
// ChipsComponent sendiri generic sepenuhnya (gak tau soal T, cuma baca id/name/selected/disabled).
// Konsumen yang nempelin `value` assert balik ke tipe ini di satu titik pas baca ulang chip yang
// di-emit, gantiin cast `any`/`unknown` yang tersebar.
export interface IChipsWithValue<T> extends IChips {
  value: T;
}
